import React from 'react'
import TableContent from '../../components/TableContent'

const url = 'connector/erp'
const item = 'ERP Connector'
const items = 'ERP Connectors'

const ConnectorERP = () => {
  return (
    <TableContent
      url={url}
      type={'connector-erp'}
      item={item}
      items={items}
    />
  )
}

export default ConnectorERP
